import React from 'react'
import FloatingActionButton from 'material-ui-legacy/FloatingActionButton'
import ActionDelete from 'material-ui-legacy/svg-icons/action/delete'
import {grey900} from 'material-ui-legacy/styles/colors'

const SmallDeleteButton = (props) => (
  <FloatingActionButton backgroundColor='#fff' mini {...props}>
    <ActionDelete style={{fill: grey900}} color={grey900} />
  </FloatingActionButton>
)

export default SmallDeleteButton



// WEBPACK FOOTER //
// ./src/components/UI/SmallDeleteButton.jsx